import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Register service worker for push notifications - deferred for better FCP
if ("serviceWorker" in navigator) {
  // Use requestIdleCallback or setTimeout to defer non-critical SW registration
  const registerSW = async () => {
    try {
      const registration = await navigator.serviceWorker.register("/sw.js");
      console.log("Service Worker registered:", registration.scope);
    } catch (error) {
      console.error("Service Worker registration failed:", error);
    }
  };
  
  if ("requestIdleCallback" in window) {
    (window as Window & { requestIdleCallback: (cb: () => void) => void }).requestIdleCallback(registerSW);
  } else {
    setTimeout(registerSW, 1000);
  }
}

createRoot(document.getElementById("root")!).render(<App />);
